import CoreModule from './core.module';

const core = new CoreModule();

export default core;

export const CoreVue = {
  install(Vue, options) {
    core.router = options.router;
    Vue.prototype.$core = core;
  },
  core,
};
